import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Button,
  Center,
  Paper,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import { useAdminAuth } from "../context/AdminAuthContext";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const from = (location.state as any)?.from || searchParams.get("from") || "/admin/dashboard";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !password.trim()) return;

    setLoading(true);
    setError("");

    const success = await login(email.trim(), password.trim());
    setLoading(false);

    if (success) {
      navigate(from, { replace: true });
    } else {
      setError("Incorrect email or password.");
    }
  };

  return (
    <Center
      style={{ minHeight: "100vh", background: "var(--background, #F8F9FA)" }}
    >
      <Paper shadow="md" p="xl" radius="md" w={400} maw="90vw">
        <form onSubmit={handleSubmit}>
          <Stack gap="md" align="center">
            <Box
              p="md"
              style={{
                borderRadius: "50%",
                backgroundColor: "#E7F1FF",
              }}
            >
              <IconLock size={32} color="#238AFF" />
            </Box>

            <Title order={3}>HAIST Admin</Title>
            <Text c="dimmed" size="sm" ta="center">
              Sign in with your Datium account
            </Text>

            <TextInput
              w="100%"
              placeholder="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
              autoFocus
            />

            <PasswordInput
              w="100%"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
              error={error}
            />

            <Button type="submit" fullWidth loading={loading} bg="#238AFF">
              Sign In
            </Button>
          </Stack>
        </form>
      </Paper>
    </Center>
  );
}
